/* global $ */
import { Controller } from '@hotwired/stimulus'

import '../src/init/datatables'

import { handleAjaxError } from '../src/init/ajax'
import { handleClickableRowClick } from '../src/mixins/with_clickable_rows'

export default class extends Controller {
  static targets = ['datatable', 'listener']
  static values = {
    filter: { type: Object, default: {} },
    source: String,
    columns: Array,
    saveState: { type: Boolean, default: false },
    order: Array
  }

  connect () {
    // Hide the search box if no column is searchable. Columns default to
    // searchable: true; only opting out everywhere disables the search.
    const anySearchable = this.columnsValue.some((col) => col.searchable !== false)

    this.datatable = $(this.datatableTarget).DataTable({
      serverSide: true,
      ajax: {
        url: this.sourceValue,
        type: 'POST',
        data: (data) => { data.filter = this.filterValue },
        error: handleAjaxError
      },
      columns: this.columnsValue,
      pageLength: 10, // add a data-page-length attribute to override
      ordering: $(this.datatableTarget).is('[data-order]'),
      searching: anySearchable,
      stateDuration: -1, // use session (per tab) storage
      stateSave: this.saveStateValue, // remember the current configuration
      drawCallback: this._drawCallback.bind(this),
      createdRow: this._createdRowCallback.bind(this)
    })
  }

  disconnect () {
    this.datatable.destroy()
  }

  _drawCallback (data) {
    const json = data.json || {}
    if (json.points) {
      this.listenerTargets.forEach(listener => {
        this.dispatch('pointsUpdated', {
          target: listener,
          detail: { points: json.points }
        })
      })
    }
  }

  // Add stimulus action to each row for clickable rows
  _createdRowCallback (row, data, dataIndex, cells) {
    row.dataset.action = 'click->remote-datatable#rowClicked'
  }

  // Finds the most relevant link to the user, and visits it (using Turbo)
  rowClicked (event) {
    handleClickableRowClick(event)
  }
}
